<template>
  <IconLogo class="the-logo" />
</template>

<script setup lang="ts">
import IconLogo from "@/icons/hms-logo.svg?component"

const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
